import {
  type FC,
  type PropsWithChildren
} from 'react';
import {
  Stack,
  Typography
} from '@mui/joy';
import {
  isDefined
} from '@shared/lib';

export type PurchaseTwoPaneLayoutHeaderProps = PropsWithChildren & {
  title?: string;
};

export const PurchaseTwoPaneLayoutHeader: FC<PurchaseTwoPaneLayoutHeaderProps> = ({ title, children }) => (
  <Stack
    alignItems='center'
    justifyContent='center'
    sx={({ breakpoints, palette }) => ({
      paddingBlockEnd: 2,
      paddingBlockStart: 1.5,
      [breakpoints.down(491)]: {
        paddingBlockStart: 2,
        paddingBlockEnd: 3.5,
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: palette.common[925],
      }
    })}>
    <Stack
      alignItems='center'
      justifyContent='flex-start'
      sx={({ breakpoints }) => ({
        rowGap: 1,
        width: '100%',
        maxWidth: 360,
        [breakpoints.down(390)]: { width: 278 },
      })}>
      {isDefined(title) && (
        <Typography
          sx={({ palette }) => ({
            width: '100%',
            fontSize: 14,
            lineHeight: '20px',
            fontStyle: 'normal',
            color: palette.common.white,
          })}>
          {title}
        </Typography>
      )}
      {children}
    </Stack>
  </Stack>
);